import { MINIAPP_PACKAGE_ID } from '@/constants';
import { getContext, isContextAvailable } from '@/miniappContext';
import { calculateWebhook } from '@/services/pluggableApiService';
import { getAppStore } from '@/store';
import { getAvailableCredits } from '@/utils/creditUtils';

/**
 * Auth + credits gate shared by the upload flows: opens the sign-in screen for
 * guests and the offer screen when credits are insufficient. Resolves `true`
 * only when the caller may proceed.
 */
export async function validateSubscription(): Promise<boolean> {
  if (!isContextAvailable()) return true;

  const ctx = getContext();
  const { id } = ctx.general.auth.getState();

  if (id == null) {
    await ctx.handlers.openAuthScreen({ action: 'signin' });
    return false;
  }

  await getAvailableCredits();

  let { toolPrice } = getAppStore();
  if (toolPrice <= 0) {
    await calculateWebhook();
    ({ toolPrice } = getAppStore());
  }

  const { availableCredits } = getAppStore();

  if (toolPrice <= 0 || availableCredits < toolPrice) {
    await ctx.handlers.openOfferScreen({ touchpoint: MINIAPP_PACKAGE_ID, action: MINIAPP_PACKAGE_ID });
    return false;
  }

  return true;
}
